import FirestoreType from './FirestoreType'

export default class UserBug extends FirestoreType {
    get title() { return this.data.title; }
    get description() { return this.data.description; }
    get date() { return this.data.date.toDate(); }
    get status() { return this.data.status; }

    get projectId() { return this.path.match(/^Project\/([^/]+)/)[1]; }
}